import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { isNonEmptyString, createCustomPropType } from '../../../../js/app/react/validators';
import View from './AverageSpentPerMonthView';
import {
  currentClientId,
  data2,
  isGoingForwardSelector,
} from '../../AdvWorkflow/AdvWorkflowSelector';
import { BACKEND_KEY } from '../ExpensesWorkflowConstants';
import { updateData } from '../../AdvWorkflow/AdvWorkflowActions';
import { selectTotalExpensesAmount, selectTotalExpenses } from '../ExpensesWorkflowSelector';
import * as PersonalInfoConstants from '../../PersonalInfoWorkflow/PersonalInfoWorkflowConstants';

const mapStateToProps = (state, ownProps) => ({
  clientId: currentClientId(state, ownProps),
  averageSpent: selectTotalExpensesAmount(state, ownProps),
  totalExpenses: selectTotalExpenses(state, ownProps),
  hasFamily:
    data2(state, ownProps)(`${PersonalInfoConstants.BACKEND_KEY}.HasPartner`) ||
    data2(state, ownProps)(`${PersonalInfoConstants.BACKEND_KEY}.HasChildren`),
  isGoingForward: isGoingForwardSelector(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  store: workflowId => (data, clientId) => dispatch(updateData(data, workflowId, clientId)),
  averageSpentChanged: (totalExpenses, clientId, storeInWorkflow) => event => {
    storeInWorkflow(
      {
        [BACKEND_KEY]: {
          ...totalExpenses,
          Amount: event.target.value,
        },
      },
      clientId,
    );
  },
});

const AverageSpentPerMonthContainer = connect(mapStateToProps, mapDispatchToProps)(View);

AverageSpentPerMonthContainer.propTypes = {
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  branch: PropTypes.arrayOf(PropTypes.number.isRequired),
};

export default AverageSpentPerMonthContainer;
